import { api, unwrap } from '@saas-kit/lib';

export interface AdminAuditLog {
  id: string;
  tenant_id: string | null;
  actor_type: string;
  actor_id: string;
  action: string;
  target_type: string;
  target_id: string;
  metadata: Record<string, unknown>;
  created_at: string;
}

export interface AdminPage {
  total: number;
  offset: number;
  limit: number;
}

export interface AdminAuditLogList {
  items: AdminAuditLog[];
  page: AdminPage;
}

export interface ListAuditLogsParams {
  offset?: number;
  limit?: number;
  tenant_id?: string | null;
  actor_id?: string | null;
  action?: string | null;
}

export async function listAuditLogs(
  params: ListAuditLogsParams = {},
): Promise<AdminAuditLogList> {
  const query: Record<string, string | number> = {
    offset: params.offset ?? 0,
    limit: params.limit ?? 50,
  };
  if (params.tenant_id && params.tenant_id.trim()) {
    query.tenant_id = params.tenant_id.trim();
  }
  if (params.actor_id && params.actor_id.trim()) {
    query.actor_id = params.actor_id.trim();
  }
  if (params.action && params.action.trim()) {
    query.action = params.action.trim();
  }
  return unwrap<AdminAuditLogList>(api.get('/admin/audit-logs', { params: query }));
}
